module.exports = __webpack_public_path__ + "static/media/playstore.95953961.svg";